"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SetAuthenticationFactor = void 0;
const tslib_1 = require("tslib");
const AuthenticationFactorStatus_1 = require("../authentication/AuthenticationFactorStatus");
const AuthenticationStatus_1 = require("../authentication/AuthenticationStatus");
const EndpointType_1 = require("../endpoint/EndpointType");
const InteractionType_1 = require("../interaction/InteractionType");
const MessageType_1 = require("../message/MessageType");
const Error_1 = require("../shared/Error");
const IResult_1 = require("../shared/IResult");
const Reason_1 = require("../shared/Reason");
const WebauthnHelpers_1 = require("../webauthn/WebauthnHelpers");
class SetAuthenticationFactor {
    constructor(setAuthenticationFactorReq, fido, joinService, authenticationFactorSetHandler) {
        this.setAuthenticationFactorReq = setAuthenticationFactorReq;
        this.fido = fido;
        this.joinService = joinService;
        this.authenticationFactorSetHandler = authenticationFactorSetHandler;
        if (this.setAuthenticationFactorReq.payload.channelInstruction.uiPages &&
            this.setAuthenticationFactorReq.payload.channelInstruction.uiPages.length > 0) {
            this.uiContent = this.setAuthenticationFactorReq.payload.channelInstruction.uiPages[0];
        }
        else {
            this.uiContent = this.setAuthenticationFactorReq.payload.channelInstruction.uiContentJSON;
        }
    }
    proceed(inputFieldAnswers) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (this.setAuthenticationFactorReq.payload.interaction.type === InteractionType_1.InteractionType.REGISTER_FIDO_AUTHENTICATOR) {
                try {
                    const { authentication, endpoint } = yield this.getFIDOInstructionResult();
                    const result = {
                        action: IResult_1.Action.APPROVED,
                    };
                    const req = this.buildAuthenticationFactorSetRequest(result, authentication, endpoint, inputFieldAnswers);
                    return this.sendRequest(req);
                }
                catch (error) {
                    if (error instanceof Error) {
                        const { result, authentication } = WebauthnHelpers_1.WebauthnHelpers.convertErrorToResult(error);
                        const endpoint = {
                            entersektJoinCode: this.joinService.getJoinCode(),
                            channelID: this.setAuthenticationFactorReq.payload.endpoint.channelID,
                            type: EndpointType_1.EndpointType.BROWSER,
                        };
                        const req = this.buildAuthenticationFactorSetRequest(result, authentication, endpoint);
                        return this.sendRequest(req);
                    }
                }
            }
            return Promise.resolve();
        });
    }
    cancel() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const result = {
                action: IResult_1.Action.DECLINED,
                reasons: [Reason_1.Reason.CUSTOMER_REJECT_ON_DEVICE],
            };
            const authentication = {
                status: AuthenticationStatus_1.AuthenticationStatus.DENIED,
            };
            const endpoint = {
                entersektJoinCode: this.joinService.getJoinCode(),
                channelID: this.setAuthenticationFactorReq.payload.endpoint.channelID,
                type: EndpointType_1.EndpointType.BROWSER,
            };
            const req = this.buildAuthenticationFactorSetRequest(result, authentication, endpoint);
            return this.sendRequest(req);
        });
    }
    sendRequest(req) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.authenticationFactorSetHandler.authenticationFactorSet(req);
        });
    }
    getFIDOInstructionResult() {
        var _a;
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const supported = this.fido.browserSupportsWebauthn();
            if (!supported) {
                return Promise.reject(new Error(Error_1.CustomerAuthnError.NOT_SUPPORTED));
            }
            const webAuthnReq = yield WebauthnHelpers_1.WebauthnHelpers.buildWebAuthnRegisterRequest(this.setAuthenticationFactorReq);
            const registerResult = yield this.fido.registerWebauthn(webAuthnReq);
            const factors = [];
            (_a = this.setAuthenticationFactorReq.payload.authentication.factors) === null || _a === void 0 ? void 0 : _a.forEach(factor => {
                const passedFactor = {
                    type: factor.type,
                    status: AuthenticationFactorStatus_1.AuthenticationFactorStatus.PASSED,
                };
                factors.push(passedFactor);
            });
            const authentication = {
                status: AuthenticationStatus_1.AuthenticationStatus.PASSED,
                factors,
                customerDataToSign: registerResult.response.clientDataJSON,
                endpointSignedData: registerResult.response.attestationObject,
            };
            const endpointType = WebauthnHelpers_1.WebauthnHelpers.convertAuthenticationFactorToEndpointType(this.setAuthenticationFactorReq.payload.authentication.factors || []);
            const endpoint = {
                channelID: this.setAuthenticationFactorReq.payload.endpoint.channelID,
                type: endpointType,
                instanceID: registerResult.id,
                entersektJoinCode: this.joinService.getJoinCode(),
            };
            return { authentication, endpoint };
        });
    }
    buildAuthenticationFactorSetRequest(result, authentication, endpoint, inputFieldAnswers) {
        return {
            messageName: MessageType_1.MessageType.AuthenticationFactorSetRequest,
            payload: {
                channelInstruction: {
                    type: this.setAuthenticationFactorReq.payload.channelInstruction.type,
                },
                messageID: this.setAuthenticationFactorReq.payload.messageID,
                interaction: {
                    entersektInteractionID: this.setAuthenticationFactorReq.payload.interaction.entersektInteractionID,
                    type: this.setAuthenticationFactorReq.payload.interaction.type,
                    inputFields: inputFieldAnswers,
                },
                result,
                endpoint,
                authentication,
            },
        };
    }
}
exports.SetAuthenticationFactor = SetAuthenticationFactor;
//# sourceMappingURL=SetAuthenticationFactor.js.map